import dynamic from "next/dynamic"

// The result strip on its own: the overlay gives it a region of its own at
// the foot of the column, whether or not a caption is up, so it wants the
// carousel without VoiceChatContent's caption column around it.
export const LazyVoiceChatPlaces = dynamic(
  () =>
    import("./voice-chat-places").then((mod) => ({
      default: mod.VoiceChatPlaces,
    })),
  { ssr: false }
)
